import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-tks-seguros',
  templateUrl: './tks-seguros.component.html',
  styleUrls: ['./tks-seguros.component.scss']
})
export class TksSegurosComponent implements OnInit {

  public client:any = null;

  constructor(
    private route: ActivatedRoute,
    private router:Router
    ) { 
      this.route.queryParams.subscribe(params => {
        console.log("PARAMS:", params);
        if(JSON.stringify(params)!='{}'){
          if(params.key && params.status && params.name && params.lastname && params.email){
            let cliente = {
              clave: params.key,
              // status: JSON.parse(params.status).paymentStatus? 'COBRO EXITOSO' : 'PENDIENTE DE PAGO',
              status: isJson(params.status)?JSON.parse(params.status).message:'ERROR',
              name: params.name,
              lastname: params.lastname,
              email: params.email
            };
            this.client = cliente;
          }else{
            console.warn("Parametros incorrectos");
            this.router.navigate(['/motor/seguros/ups-error']);
          }
      }else{
        console.warn("No hay parametros")
        this.router.navigate(['/motor/seguros/ups-error']);
      }
      
    });
  }

  ngOnInit() {
  }

}

function isJson(str) {
  try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}
